<template>
  <div class="flex-column h100">
    <navbar title="工厂工作量统计"></navbar>
    <div class="flex1 workload flex-column h100">
      <div class="mt10">
        <el-card class="box-card">
          <div>
            <div class="inblock">
              统计日期:
              <el-date-picker
                v-model="time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </div>
            <div class="inblock ml10">
              统计岗位:
              <el-select v-model="value1" placeholder="请选择">
                <el-option
                  v-for="item in options1"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </div>
            <div class="inblock ml10">
              操作伙伴:
              <el-select v-model="value2" placeholder="请选择">
                <el-option
                  v-for="item in options2"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
          </div>
        </el-card>
      </div>
      <div class="flex1 mt10">
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          :height="tableHeight"
          :row-class-name="tableRowClassName"
        >
          <el-table-column prop="startTime" label="开始时间" sortable></el-table-column>
          <el-table-column prop="endTime" label="结束时间" sortable></el-table-column>
          <el-table-column prop="factory_member_name" label="伙伴"></el-table-column>
          <el-table-column prop="factory_position_id" label="岗位"></el-table-column>
          <el-table-column prop="totalCount" label="工作计件"></el-table-column>
          <el-table-column prop="return_percent" label="返工率"></el-table-column>
          <el-table-column prop="position_money" label="营业额度"></el-table-column>
        </el-table>
      </div>
      <div class="bottom mt10">
        <span
          v-for="(item,index) in allCount"
          :key="index"
        >{{item.position_name}}: {{item.allCount}}件</span>
      </div>
    </div>
  </div>
</template>
<script>
import header from '@/components/header'
export default {
  components: {
    navbar: header
  },
  data() {
    return {
      tableHeight: window.innerHeight - 200,
      time: [new Date(), new Date()],
      options1: [],
      options2: [],
      value1: '',
      value2: '',
      tableData: [],
      allCount: []
    }
  },
  created() {
    this.time[0] = this.$utils.formatTime(new Date().getTime(), 'Y-M-D')
    this.time[1] = this.$utils.formatTime(new Date().getTime(), 'Y-M-D')
    Promise.all([this.qSelect(), this.workCount()])
  },
  methods: {
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 == 0) {
        return 'warning-row';
      }
      return '';
    },
    async workCount() {
      let data = {
        startTime: this.time[0],
        endTime: this.time[1],
        stationID: this.value1 != '请选择' ? this.value1 : '',
        userID: this.value2
      }
      let res = await this.$http.workCount(data)
      this.tableData = res.data.data.positionCount
      this.allCount = res.data.data.allCount
    },
    async qSelect() {
      let res1 = await this.$http.allPosition()
      let res2 = await this.$http.allPeople()
      this.options1 = [{ id: null, name: '请选择' }, ...res1.data.data]
      this.options2 = [{ id: null, name: '请选择' }, ...res2.data.data]
    }
  },
  watch: {
    value1() {
      this.workCount()
    },
    value2() {
      this.workCount()
    },
    time() {
      this.workCount()
    }
  }
}
</script>
<style lang="less" scoped>
.workload {
  padding: 0 10px 30px 10px;
  box-sizing: border-box;
  .bottom {
    text-align: center;
    span {
      margin: 0 20px;
    }
  }
}
</style>